import {useLocation} from "react-router-dom";
import Item from "./Item";
import {itemIsActive} from "../../utils/itemIsActive";

export default function MessagesItem() {
  const url = useLocation();

  return (
    <Item
      link={'/messages'}
      label={'Сообщения'}
      active={itemIsActive(url.pathname, ['/messages'])}
    />
  );
}